<script setup lang="ts">import { computed as _computed } from 'vue';

import { onMounted } from "vue";
import { useRouter } from "vue-router";

import { RsAutocomplete } from "@/components";

import { useCaseFileStore } from "@/stores/case-file-store";
import { useMetadataStore } from "@/stores/metadata-store";

withDefaults(defineProps<{
  brand: string;
  caseReference: string;
}>(), {  })
const $router = useRouter();

onMounted(() => {
  // TODO
  // Mousetrap.bindGlobal('alt+n alt+n', () => (this.$refs.next.$el! as HTMLElement).click());
  // Mousetrap.bindGlobal('alt+n alt+p', () => (this.$refs.prev.$el! as HTMLElement).click());
  // Mousetrap.bindGlobal('alt+n alt+s', this.focusSearch);
});

const item = _computed(() => {
  return useCaseFileStore().currentFile;
});

const viewing = _computed({
  get() {
    return item.value?.displayName;
  },
  set(_value?: string) {
    // onViewingChanged(value);
    // Do nothing
  },
});

const itemIndex = _computed(() => {
  if (!useCaseFileStore().currentFile) {
    return -1;
  }

  return useMetadataStore().filteredFilesInCurrentFolder.findIndex(
    (f) => f.fileReference === useCaseFileStore().currentFile!.fileReference,
  );
});

const nextReference = _computed(() => {
  if (itemIndex.value < 0) {
    return null;
  }
  if (itemIndex.value < useMetadataStore().filteredFilesInCurrentFolder.filter((f) => !f.isDuplicate).length - 1) {
    return useMetadataStore().filteredFilesInCurrentFolder.filter((f) => !f.isDuplicate)[itemIndex.value + 1].original;
  } else return null;
});

const prevReference = _computed(() => {
  if (itemIndex.value < 0) {
    return null;
  }
  return itemIndex.value > 0
    ? useMetadataStore().filteredFilesInCurrentFolder.filter((f) => !f.isDuplicate)[itemIndex.value - 1].original
    : null;
});

const fileNames = _computed(() => {
  return useMetadataStore().filteredFilesInCurrentFolder.map((m) => m.displayName);
});

function onViewingChanged(to?: string) {
  if (!to) {
    return;
  }

  const file = useMetadataStore().filteredFilesInCurrentFolder.find((f) => f.displayName === to);

  if (!file) {
    return;
  }

  $router.push(`/${__props.brand}/${__props.caseReference}/${file.original}`);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function focusSearch(): void {
  // TODO
  // searchRef.$el.getElementsByTagName('input')[0].focus();
}
</script>
<template>
  <div>
    <component
      :is="prevReference ? 'router-link' : 'button'"
      class="tw-btn-md-gray tw-grid tw-shrink-0 tw-place-items-center hover:tw-text-white"
      :disabled="!prevReference"
      :to="prevReference ? `/${brand}/${caseReference}/${prevReference}` : undefined"
    >
      &lt;
    </component>
    <RsAutocomplete
      v-model="viewing"
      placeholder="Type to search files"
      classes="typeahead tw-mx-1 tw-flex-1 small"
      :limit="20"
      :is-search="true"
      :object-array="fileNames"
      @hit="onViewingChanged"
    />
    <component
      :is="nextReference ? 'router-link' : 'button'"
      class="tw-btn-md-gray tw-grid tw-shrink-0 tw-place-items-center hover:tw-text-white"
      :disabled="!nextReference"
      :to="nextReference ? `/${brand}/${caseReference}/${nextReference}` : undefined"
    >
      &gt;
    </component>
  </div>
</template>
